import type { ContactCreateInput } from "@/lib/gql/__generated__/graphql";

import type { ContactCreateInputZodSchemaType } from "../../../schema";

type Props = {
	contact: ContactCreateInputZodSchemaType;
};

export const convertToToInput = ({ contact }: Props) => {
	const replyTrimmed = contact.hostReplyToMail?.trim();
	const input: ContactCreateInput = {
		hotelID: contact.hotelID,
		title: contact.title,
		contactGenre: contact.contactGenre,
		reservationID: contact.reservationID,
		message: contact.message,
		...(replyTrimmed ? { hostReplyToMail: replyTrimmed } : {}),
	} satisfies ContactCreateInput;

	return input;
};
